// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control:focus {
  border-color: #3a7425;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);
}

.employee-creation-container .active1 {
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}
.employee-creation-container .back_square {
  background-color: #e0f1da;
  width: 50px !important;
  height: 50px !important;
  border-radius: 10px;
  justify-content: flex-start;
  align-items: end;
}
.employee-creation-container .form-control {
  border-color: #d9d9d9;
}
.employee-creation-container .card {
  margin-bottom: 20px;
}
.employee-creation-container .note {
  background-color: #eaeff7;
  border-color: #2e61b4;
  margin-bottom: 5px;
}
.employee-creation-container .note i {
  color: #6797e6;
}
.employee-creation-container .stickyCard-section .stickyCard {
  position: sticky;
  top: 15%;
  z-index: 999;
}
.employee-creation-container .stickyCard-section .hiddenNav {
  display: block;
  opacity: 1;
  transition: opacity 1s ease-in-out;
}
.employee-creation-container .stickyCard-section .scrolledNav {
  display: none;
  opacity: 0;
}
.employee-creation-container .assignment-section {
  position: relative;
}
.employee-creation-container .assignment-section .remove-btn {
  right: 5px;
  position: absolute;
  bottom: 0;
}
.employee-creation-container .assignment-section button {
  padding: 1rem;
  border: none;
  background: none;
  color: #3a7425;
  font-size: 20px;
  font-weight: 500;
}
.employee-creation-container .assignment-section .add-btn {
  position: absolute;
  bottom: 0px;
  display: flex;
  right: 120px;
}

.service-card .card {
  padding: 20px;
  font-weight: 500;
  margin-bottom: 20px;
  border-radius: 12px;
  background-color: #f9fdf7;
  border-color: rgba(69, 133, 46, 0.3215686275);
}

.btn.forward-btn,
.forward-btn:hover {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  justify-content: flex-start;
  align-items: end;
  background-color: #e0f1da;
  color: #3a7425;
  border: none;
}

.fw-500 {
  font-weight: 500;
}

.verify-btn,
.verify-btn:hover {
  background-color: #3a7425;
  color: #d9d9d9;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

.stickyCard-section,
.form-section {
  margin-bottom: 5%;
}

::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

::-webkit-scrollbar-thumb {
  background-color: #bdbdbd;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.know-more {
  cursor: pointer;
}

.Estate {
  border-radius: 18px;
  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.Estate .Eearth {
  height: 32px;
  width: 32px;
}
.Estate .innercard11,
.Estate .innercard12 {
  border-radius: 12px;
  cursor: pointer;
  background-color: #edf4eb;
}
.Estate .innercard11 p,
.Estate .innercard12 p {
  font-family: Karla;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.02em;
  text-align: left;
}
.Estate .innercard11 h4,
.Estate .innercard12 h4 {
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.02em;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.Estate .innercard21,
.Estate .innercard22,
.Estate .innercard31,
.Estate .innercard32,
.Estate .innercard41,
.Estate .innercard42,
.Estate .innercard51,
.Estate .innercard52 {
  border-radius: 12px;
  cursor: pointer;
  background-color: #fff;
}
.Estate .innercard21 p,
.Estate .innercard22 p,
.Estate .innercard31 p,
.Estate .innercard32 p,
.Estate .innercard41 p,
.Estate .innercard42 p,
.Estate .innercard51 p,
.Estate .innercard52 p {
  font-family: Karla;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1rem;
  letter-spacing: -0.02em;
  text-align: left;
}
.Estate .innercard21 h4,
.Estate .innercard22 h4,
.Estate .innercard31 h4,
.Estate .innercard32 h4,
.Estate .innercard41 h4,
.Estate .innercard42 h4,
.Estate .innercard51 h4,
.Estate .innercard52 h4 {
  font-family: Inter;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: -0.02em;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}
.Estate .heading-color-1 {
  color: #45852e;
}
.Estate .heading-color-2,
.Estate .heading-color-3 {
  color: #000;
}
.Estate .heading-color-4,
.Estate .heading-color-5 {
  color: #fff;
}
.Estate .inner-box-1 {
  background-color: #000;
}
.Estate .Earrow {
  width: 16px;
  height: 16px;
}
.Estate .footer_common,
.Estate .footer {
  font-family: Karla;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: -0.04em;
  text-align: left;
  color: #516900;
  text-wrap: nowrap;
}

.search_application_parents {
  font-family: Inter;
}
.search_application_parents .search_application_heading {
  font-size: 24px;
  font-weight: 500;
  line-height: 29px;
  letter-spacing: -0.02em;
  text-align: left;
}
.search_application_parents .search_application_label {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 8px;
}
.search_application_parents .search_application_placeholder,
.search_application_parents ::placeholder {
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: rgba(0, 0, 0, 0.8);
}

.activate-modal {
  top: -100px;
  width: 600px;
}

.clarification-body {
  width: 100%;
  height: 400px;
  padding: 20px;
  overflow-y: auto;
  background: #f5f5f6;
}

.clarification-modal {
  height: 50vh;
}

.icon-container {
  position: absolute;
  top: 25%;
  right: 5%;
}

.controlling_ownership_button {
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0px;
  background: linear-gradient(0deg, rgba(69, 133, 46, 0.1), rgba(69, 133, 46, 0.1));
  border: 1px dashed #45852e;
}

.new-dashboard .greeting {
  line-height: 19.2px;
  letter-spacing: -0.02em;
  color: #000000;
}
.new-dashboard .user-name {
  line-height: 33.6px;
  color: #000000;
}
.new-dashboard .content {
  color: #333e48;
}
.new-dashboard .content .content-heading {
  line-height: 29.05px;
  letter-spacing: -0.02em;
}
.new-dashboard .content .content-details {
  line-height: 16.94px;
  letter-spacing: -0.02em;
}
.new-dashboard .content .new-dashboard-button {
  min-width: 235px;
}

.new-enterprise-dashboard .finacial-year {
  color: #272727;
}
.new-enterprise-dashboard .plot-list {
  width: max-content;
  max-width: 100%;
  background: rgba(51, 62, 72, 0.0784313725);
  padding: 10px;
}
.new-enterprise-dashboard .plot-list .plot-items {
  color: rgba(50, 62, 74, 0.6);
  line-height: 17.6px;
}
.new-enterprise-dashboard .payment-details .payment-cards,
.new-enterprise-dashboard .sub-lease-status .payment-cards {
  transition: width 0.5s;
}
.new-enterprise-dashboard .payment-details .payment-card1,
.new-enterprise-dashboard .sub-lease-status .payment-card1 {
  background: #b7cf53;
  color: #000;
}
.new-enterprise-dashboard .payment-details .payment-card2,
.new-enterprise-dashboard .sub-lease-status .payment-card2 {
  background: #80b036;
  color: #000;
}
.new-enterprise-dashboard .payment-details .payment-card3,
.new-enterprise-dashboard .sub-lease-status .payment-card3 {
  background: #45852e;
  color: #fff;
}
.new-enterprise-dashboard .payment-details .payment-card4,
.new-enterprise-dashboard .sub-lease-status .payment-card4 {
  background: #323e4a;
  color: #fff;
}
.new-enterprise-dashboard .payment-details .font-color-1,
.new-enterprise-dashboard .payment-details .font-color-2,
.new-enterprise-dashboard .sub-lease-status .font-color-1,
.new-enterprise-dashboard .sub-lease-status .font-color-2 {
  color: #000;
}
.new-enterprise-dashboard .payment-details .font-color-3,
.new-enterprise-dashboard .payment-details .font-color-4,
.new-enterprise-dashboard .sub-lease-status .font-color-3,
.new-enterprise-dashboard .sub-lease-status .font-color-4 {
  color: #fff;
}
.new-enterprise-dashboard .payment-details .icon-background,
.new-enterprise-dashboard .sub-lease-status .icon-background {
  box-shadow: 0px 1px 4px 0px rgba(108, 156, 34, 0.0784313725);
}
.new-enterprise-dashboard .payment-details .paid,
.new-enterprise-dashboard .payment-details .Paid,
.new-enterprise-dashboard .sub-lease-status .paid,
.new-enterprise-dashboard .sub-lease-status .Paid {
  background: #ddecdc;
  color: #45852e;
}
.new-enterprise-dashboard .payment-details .due,
.new-enterprise-dashboard .payment-details .Due,
.new-enterprise-dashboard .sub-lease-status .due,
.new-enterprise-dashboard .sub-lease-status .Due {
  background: #ece6dc;
  color: #987a2d;
}
.new-enterprise-dashboard .payment-details .overdue,
.new-enterprise-dashboard .payment-details .Overdue,
.new-enterprise-dashboard .sub-lease-status .overdue,
.new-enterprise-dashboard .sub-lease-status .Overdue {
  color: #852e2e;
  background: #ece6dc;
}
.new-enterprise-dashboard .payment-details .na,
.new-enterprise-dashboard .payment-details .NA,
.new-enterprise-dashboard .sub-lease-status .na,
.new-enterprise-dashboard .sub-lease-status .NA {
  background: rgba(255, 255, 255, 0.1607843137);
  color: #fff;
  width: 4.25rem;
  display: flex;
  justify-content: center;
}
.new-enterprise-dashboard .new-dashboard-details .document-card {
  height: 100%;
}
.new-enterprise-dashboard .new-dashboard-details .document-card .document-details .documnet-name {
  color: #1d1d1d;
}
.new-enterprise-dashboard .new-dashboard-details .document-card .document-details .document-date {
  color: #828282;
}
.new-enterprise-dashboard .new-dashboard-details .document-card .document-details .option-list {
  box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.1215686275);
  width: max-content;
  top: 1rem;
}
.new-enterprise-dashboard .new-dashboard-details .document-card .document-details .option-list div:hover {
  color: #45852e;
  background: #eff9ef;
}
.new-enterprise-dashboard .new-dashboard-details .option-list {
  box-shadow: 2px 4px 16px 0px rgba(0, 0, 0, 0.1215686275);
  width: max-content;
  top: 1rem;
}
.new-enterprise-dashboard .new-dashboard-details .option-list div:hover {
  color: #45852e;
  background: #eff9ef;
}
.new-enterprise-dashboard .payment-card-parents::-webkit-scrollbar {
  width: 1px; /* Adjust the width of the scrollbar */
  height: 1px;
}
.new-enterprise-dashboard .payment-card-parents::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0); /* Scrollbar color */
  border-radius: 1px; /* Rounded corners */
}
.new-enterprise-dashboard .payment-card-parents::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0); /* Track color */
}

.serach-table-md {
  width: 8%;
}

.entity-name-md {
  width: 12.5%;
}

.date-of-submission-md {
  width: 10%;
}

.status-md {
  width: 10%;
}

.estate-details-md {
  width: 8.24%;
}

.search-application-am-md {
  width: 12.5%;
}

.search-application-am-pendency-md {
  width: 8%;
}

.search-application-am-type-md {
  width: 14.75%;
}

.search-application-it-md {
  width: 11.5%;
}

.inbox-application-md-1 {
  width: 20%;
}

.inbox-application-md-2 {
  width: 15%;
}

.inbox-application-md-3 {
  width: 10%;
}`, "",{"version":3,"sources":["webpack://./src/features/modules/UserManagement/UserManagement.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EAGA,0CAAA;AACJ;;AAGI;EACI,0CAAA;AAAR;AAGI;EACI,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AADR;AAII;EACI,qBAAA;AAFR;AAKI;EACI,mBAAA;AAHR;AAMI;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;AAJR;AAMQ;EACI,cAAA;AAJZ;AASQ;EAEI,gBAAA;EACA,QAAA;EACA,YAAA;AAPZ;AAUQ;EACI,cAAA;EACA,UAAA;EACA,kCAAA;AARZ;AAWQ;EACI,aAAA;EACA,UAAA;AATZ;AAaI;EACI,kBAAA;AAXR;AAaQ;EACI,UAAA;EACA,kBAAA;EACA,SAAA;AAXZ;AAcQ;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAZZ;AAeQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AAbZ;;AAmBI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6CAAA;AAhBR;;AAoBA;;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;AAjBJ;;AAoBA;EACI,gBAAA;AAjBJ;;AAoBA;;EAEI,yBAAA;EACA,cAAA;AAjBJ;;AAoBA;;EAII,gBAAA;EACA,SAAA;AAjBJ;;AAoBA;;EAEI,iBAAA;AAjBJ;;AAoBA;EACI,WAAA;EACA,mCAAA;AAjBJ;;AAoBA;EACI,yBAAA;EACA,yCAAA;AAjBJ;;AAoBA;EACI,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iDAAA;AAjBJ;;AAwBA;EACI,eAAA;AArBJ;;AAwBA;EACI,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AArBJ;AAuBI;EACI,YAAA;EACA,WAAA;AArBR;AAwBI;;EAEI,mBAAA;EACA,eAAA;EACA,yBAAA;AAtBR;AAwBQ;;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AArBZ;AAwBQ;;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AArBZ;AAyBI;;;;;;;;EAQI,mBAAA;EACA,eAAA;EACA,sBAAA;AAvBR;AAyBQ;;;;;;;;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAhBZ;AAmBQ;;;;;;;;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;AAVZ;AAcI;EACI,cAAA;AAZR;AAeI;;EAEI,WAAA;AAbR;AAgBI;;EAEI,WAAA;AAdR;AAiBI;EACI,sBAAA;AAfR;AAkBI;EACI,WAAA;EACA,YAAA;AAhBR;AAmBI;;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAjBR;;AAqBA;EACI,kBAAA;AAlBJ;AAoBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AAlBR;AAqBI;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAnBR;AAsBI;;EAEI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AApBR;;AAyBA;EACI,WAAA;EACA,YAAA;AAtBJ;;AA2BA;EACI,WAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAxBJ;;AA2BA;EACI,YAAA;AAxBJ;;AA2BA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAxBJ;;AA4BA;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iFAAA;EACA,0BAAA;AAzBJ;;AA4BI;EACI,mBAAA;EACA,uBAAA;EACA,cAAA;AAzBR;AA2BI;EACI,mBAAA;EACA,cAAA;AAzBR;AA2BI;EACI,cAAA;AAzBR;AA0BQ;EACI,oBAAA;EACA,uBAAA;AAxBZ;AA0BQ;EACI,oBAAA;EACA,uBAAA;AAxBZ;AA0BQ;EACI,gBAAA;AAxBZ;;AA6BI;EACI,cAAA;AA1BR;AA4BI;EACI,kBAAA;EACA,eAAA;EACA,0CAAA;EAEA,aAAA;AA3BR;AA4BQ;EACI,4BAAA;EACA,mBAAA;AA1BZ;AA+BQ;;EACI,sBAAA;AA5BZ;AA8BQ;;EACI,mBAAA;EACA,WAAA;AA3BZ;AA6BQ;;EACI,mBAAA;EACA,WAAA;AA1BZ;AA4BQ;;EACI,mBAAA;EACA,WAAA;AAzBZ;AA2BQ;;EACI,mBAAA;EACA,WAAA;AAxBZ;AA2BQ;;;;EAEI,WAAA;AAvBZ;AA0BQ;;;;EAEI,WAAA;AAtBZ;AAwBQ;;EACI,4DAAA;AArBZ;AAuBQ;;;;EAEI,mBAAA;EACA,cAAA;AAnBZ;AAqBQ;;;;EAEI,mBAAA;EACA,cAAA;AAjBZ;AAmBQ;;;;EAEI,cAAA;EACA,mBAAA;AAfZ;AAiBQ;;;;EAEI,6CAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;AAbZ;AAiBQ;EACI,YAAA;AAfZ;AAiBgB;EACI,cAAA;AAfpB;AAiBgB;EACI,cAAA;AAfpB;AAiBgB;EACI,wDAAA;EACA,kBAAA;EACA,SAAA;AAfpB;AAiBwB;EACI,cAAA;EACA,mBAAA;AAf5B;AAqBQ;EACI,wDAAA;EACA,kBAAA;EACA,SAAA;AAnBZ;AAqBgB;EACI,cAAA;EACA,mBAAA;AAnBpB;AAwBI;EACI,UAAA,EAAA,sCAAA;EACA,WAAA;AAtBR;AAyBI;EACI,kCAAA,EAAA,oBAAA;EACA,kBAAA,EAAA,oBAAA;AAvBR;AA0BI;EACI,wCAAA,EAAA,gBAAA;AAxBR;;AA4BA;EACI,SAAA;AAzBJ;;AA4BA;EACI,YAAA;AAzBJ;;AA4BA;EACI,UAAA;AAzBJ;;AA4BA;EACI,UAAA;AAzBJ;;AA4BA;EACI,YAAA;AAzBJ;;AA4BA;EACI,YAAA;AAzBJ;;AA4BA;EACI,SAAA;AAzBJ;;AA4BA;EACI,aAAA;AAzBJ;;AA4BA;EACI,YAAA;AAzBJ;;AA4BA;EACI,UAAA;AAzBJ;;AA4BA;EACI,UAAA;AAzBJ;;AA4BA;EACI,UAAA;AAzBJ","sourcesContent":[".form-control:focus {\n    border-color: #3a7425;\n    -webkit-box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n    -moz-box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n    box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.employee-creation-container {\n    .active1 {\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n    }\n\n    .back_square {\n        background-color: #e0f1da;\n        width: 50px !important;\n        height: 50px !important;\n        border-radius: 10px;\n        justify-content: flex-start;\n        align-items: end;\n    }\n\n    .form-control {\n        border-color: #d9d9d9;\n    }\n\n    .card {\n        margin-bottom: 20px;\n    }\n\n    .note {\n        background-color: #eaeff7;\n        border-color: #2e61b4;\n        margin-bottom: 5px;\n\n        i {\n            color: #6797e6;\n        }\n    }\n\n    .stickyCard-section {\n        .stickyCard {\n            position: -webkit-sticky;\n            position: sticky;\n            top: 15%;\n            z-index: 999;\n        }\n\n        .hiddenNav {\n            display: block;\n            opacity: 1;\n            transition: opacity 1s ease-in-out;\n        }\n\n        .scrolledNav {\n            display: none;\n            opacity: 0;\n        }\n    }\n\n    .assignment-section {\n        position: relative;\n\n        .remove-btn {\n            right: 5px;\n            position: absolute;\n            bottom: 0;\n        }\n\n        button {\n            padding: 1rem;\n            border: none;\n            background: none;\n            color: #3a7425;\n            font-size: 20px;\n            font-weight: 500;\n        }\n\n        .add-btn {\n            position: absolute;\n            bottom: 0px;\n            display: flex;\n            right: 120px;\n        }\n    }\n}\n\n.service-card {\n    .card {\n        padding: 20px;\n        font-weight: 500;\n        margin-bottom: 20px;\n        border-radius: 12px;\n        background-color: #f9fdf7;\n        border-color: #45852e52;\n    }\n}\n\n.btn.forward-btn,\n.forward-btn:hover {\n    width: 50px;\n    height: 50px;\n    border-radius: 10px;\n    justify-content: flex-start;\n    align-items: end;\n    background-color: #e0f1da;\n    color: #3a7425;\n    border: none;\n}\n\n.fw-500 {\n    font-weight: 500;\n}\n\n.verify-btn,\n.verify-btn:hover {\n    background-color: #3a7425;\n    color: #d9d9d9;\n}\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    margin: 0;\n}\n\n.stickyCard-section,\n.form-section {\n    margin-bottom: 5%;\n}\n\n::-webkit-scrollbar {\n    width: 12px;\n    /* Set the width of the scrollbar */\n}\n\n::-webkit-scrollbar-track {\n    background-color: #f1f1f1;\n    /* Set the color of the scrollbar track */\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: #bdbdbd;\n    /* Set the color of the scrollbar thumb */\n    border-radius: 6px;\n    /* Set the border radius of the scrollbar thumb */\n}\n\n// ::-webkit-scrollbar-thumb:hover {\n//   background-color: #3a7425; /* Set the color of the scrollbar thumb on hover */\n// }\n\n.know-more {\n    cursor: pointer;\n}\n\n.Estate {\n    border-radius: 18px;\n    font-family: Inter;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 22px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #000000cc;\n\n    .Eearth {\n        height: 32px;\n        width: 32px;\n    }\n\n    .innercard11,\n    .innercard12 {\n        border-radius: 12px;\n        cursor: pointer;\n        background-color: #edf4eb;\n\n        p {\n            font-family: Karla;\n            font-size: 1rem;\n            font-weight: 500;\n            line-height: 1rem;\n            letter-spacing: -0.02em;\n            text-align: left;\n        }\n\n        h4 {\n            font-family: Inter;\n            font-size: 1.5rem;\n            font-weight: 500;\n            line-height: 1.25;\n            letter-spacing: -0.02em;\n            text-align: left;\n            color: #000000cc;\n        }\n    }\n\n    .innercard21,\n    .innercard22,\n    .innercard31,\n    .innercard32,\n    .innercard41,\n    .innercard42,\n    .innercard51,\n    .innercard52 {\n        border-radius: 12px;\n        cursor: pointer;\n        background-color: #fff;\n\n        p {\n            font-family: Karla;\n            font-size: 1rem;\n            font-weight: 500;\n            line-height: 1rem;\n            letter-spacing: -0.02em;\n            text-align: left;\n        }\n\n        h4 {\n            font-family: Inter;\n            font-size: 1.5rem;\n            font-weight: 500;\n            line-height: 1.25;\n            letter-spacing: -0.02em;\n            text-align: left;\n            color: #000000cc;\n        }\n    }\n\n    .heading-color-1 {\n        color: #45852e;\n    }\n\n    .heading-color-2,\n    .heading-color-3 {\n        color: #000;\n    }\n\n    .heading-color-4,\n    .heading-color-5 {\n        color: #fff;\n    }\n\n    .inner-box-1 {\n        background-color: #000;\n    }\n\n    .Earrow {\n        width: 16px;\n        height: 16px;\n    }\n\n    .footer_common,\n    .footer {\n        font-family: Karla;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 14px;\n        letter-spacing: -0.04em;\n        text-align: left;\n        color: #516900;\n        text-wrap: nowrap;\n    }\n}\n\n.search_application_parents {\n    font-family: Inter;\n\n    .search_application_heading {\n        font-size: 24px;\n        font-weight: 500;\n        line-height: 29px;\n        letter-spacing: -0.02em;\n        text-align: left;\n    }\n\n    .search_application_label {\n        font-size: 14px;\n        font-weight: 400;\n        letter-spacing: 0px;\n        text-align: left;\n        margin-bottom: 8px;\n    }\n\n    .search_application_placeholder,\n    ::placeholder {\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 22px;\n        letter-spacing: 0px;\n        text-align: left;\n        color: #000000cc;\n    }\n}\n\n// EMPLOYEE SEARCH\n.activate-modal {\n    top: -100px;\n    width: 600px;\n}\n\n//NOC Clarification History Modal\n\n.clarification-body {\n    width: 100%;\n    height: 400px;\n    padding: 20px;\n    overflow-y: auto;\n    background: #f5f5f6;\n}\n\n.clarification-modal {\n    height: 50vh;\n}\n\n.icon-container {\n    position: absolute;\n    top: 25%;\n    right: 5%;\n    // height: 100%;\n}\n\n.controlling_ownership_button {\n    font-family: Inter;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 26px;\n    letter-spacing: 0px;\n    background: linear-gradient(0deg, rgba(69, 133, 46, 0.1), rgba(69, 133, 46, 0.1));\n    border: 1px dashed #45852e;\n}\n.new-dashboard {\n    .greeting {\n        line-height: 19.2px;\n        letter-spacing: -0.02em;\n        color: #000000;\n    }\n    .user-name {\n        line-height: 33.6px;\n        color: #000000;\n    }\n    .content {\n        color: #333e48;\n        .content-heading {\n            line-height: 29.05px;\n            letter-spacing: -0.02em;\n        }\n        .content-details {\n            line-height: 16.94px;\n            letter-spacing: -0.02em;\n        }\n        .new-dashboard-button {\n            min-width: 235px;\n        }\n    }\n}\n.new-enterprise-dashboard {\n    .finacial-year {\n        color: #272727;\n    }\n    .plot-list {\n        width: max-content;\n        max-width: 100%;\n        background: #333e4814;\n        // height: 48px;\n        padding: 10px;\n        .plot-items {\n            color: #323e4a99;\n            line-height: 17.6px;\n        }\n    }\n    .payment-details,\n    .sub-lease-status {\n        .payment-cards {\n            transition: width 0.5s;\n        }\n        .payment-card1 {\n            background: #b7cf53;\n            color: #000;\n        }\n        .payment-card2 {\n            background: #80b036;\n            color: #000;\n        }\n        .payment-card3 {\n            background: #45852e;\n            color: #fff;\n        }\n        .payment-card4 {\n            background: #323e4a;\n            color: #fff;\n        }\n\n        .font-color-1,\n        .font-color-2 {\n            color: #000;\n        }\n\n        .font-color-3,\n        .font-color-4 {\n            color: #fff;\n        }\n        .icon-background {\n            box-shadow: 0px 1px 4px 0px #6c9c2214;\n        }\n        .paid,\n        .Paid {\n            background: #ddecdc;\n            color: #45852e;\n        }\n        .due,\n        .Due {\n            background: #ece6dc;\n            color: #987a2d;\n        }\n        .overdue,\n        .Overdue {\n            color: #852e2e;\n            background: #ece6dc;\n        }\n        .na,\n        .NA {\n            background: #ffffff29;\n            color: #fff;\n            width: 4.25rem;\n            display: flex;\n            justify-content: center;\n        }\n    }\n    .new-dashboard-details {\n        .document-card {\n            height: 100%;\n            .document-details {\n                .documnet-name {\n                    color: #1d1d1d;\n                }\n                .document-date {\n                    color: #828282;\n                }\n                .option-list {\n                    box-shadow: 2px 4px 16px 0px #0000001f;\n                    width: max-content;\n                    top: 1rem;\n                    div {\n                        &:hover {\n                            color: #45852e;\n                            background: #eff9ef;\n                        }\n                    }\n                }\n            }\n        }\n        .option-list {\n            box-shadow: 2px 4px 16px 0px #0000001f;\n            width: max-content;\n            top: 1rem;\n            div {\n                &:hover {\n                    color: #45852e;\n                    background: #eff9ef;\n                }\n            }\n        }\n    }\n    .payment-card-parents::-webkit-scrollbar {\n        width: 1px; /* Adjust the width of the scrollbar */\n        height: 1px;\n    }\n\n    .payment-card-parents::-webkit-scrollbar-thumb {\n        background-color: rgba(0, 0, 0, 0); /* Scrollbar color */\n        border-radius: 1px; /* Rounded corners */\n    }\n\n    .payment-card-parents::-webkit-scrollbar-track {\n        background-color: rgba(255, 255, 255, 0); /* Track color */\n    }\n}\n\n.serach-table-md {\n    width: 8%;\n}\n\n.entity-name-md {\n    width: 12.5%;\n}\n\n.date-of-submission-md {\n    width: 10%;\n}\n\n.status-md {\n    width: 10%;\n}\n\n.estate-details-md {\n    width: 8.24%;\n}\n\n.search-application-am-md {\n    width: 12.5%;\n}\n\n.search-application-am-pendency-md {\n    width: 8%;\n}\n\n.search-application-am-type-md {\n    width: 14.75%;\n}\n\n.search-application-it-md {\n    width: 11.5%;\n}\n\n.inbox-application-md-1 {\n    width: 20%;\n}\n\n.inbox-application-md-2 {\n    width: 15%;\n}\n\n.inbox-application-md-3 {\n    width: 10%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
